import { NodeData } from "src/constants/NodeDataTypes";

export const backupExtractFields = (data: NodeData) => {
  return [
    {
      id: null,
      value: JSON.stringify(data),
    },
  ];
};
